// extracted by mini-css-extract-plugin
module.exports = {"container":"ELSScoreBreakdown_container__2FLEN","elsSpan":"ELSScoreBreakdown_elsSpan__X1fZn"};